import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-pricing-plans',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './pricing-plans.html',
  styleUrls: ['./pricing-plans.css'],
})
export class PricingPlansComponent {
  @Input() isYearly = false;
}
